module.exports = __webpack_public_path__ + "font/fontello.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_mavon-editor@2.9.1@mavon-editor/dist/font/fontello.eot
// module id = 13
// module chunks = 0